function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "product_table-runner");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M30.619 10.675v-5.325h-29.288v5.325h-1.331v10.65h1.331v5.325h29.288v-5.325h1.331v-10.65zM29.288 25.319h-26.626v-3.994h26.626zM30.619 19.994h-29.288v-7.988h3.994c0.8 0 1.331-0.532 1.331-1.331h-3.994v-3.994h26.626v3.994h-21.3c0 0.8 0.532 1.331 1.331 1.331h21.3z"
});

var SvgProductTableRunner = function SvgProductTableRunner(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgProductTableRunner, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/product_table-runner.d9a365a5.svg";
export { ForwardRef as ReactComponent };